import ABaseComponent from '../../ABaseComponent';
import ComponentMap from '../../ComponentMap';
import Page from "./Page"

export default class Route extends ABaseComponent {

    constructor(props) {
        super(props);
        this.id = this.props.id;
        if(!window.location.hash&&this.props.jsPath){
            this.state = {
                ...this.props
            }
            window.location.hash = this.props.jsPath
        }
        else if(!!window.location.hash){
            this.state = {
                ...this.props,
               jsPath:window.location.hash&&window.location.hash.split('?')[0].substring(1)
            }
        }
    }

    componentDidMount() {
        ComponentMap.put(this.id, this);
        window.onhashchange = () =>{ 
            this.setState({ jsPath:window.location.hash&&window.location.hash.split('?')[0].substring(1)})
            this.props.onhashchange && this.props.onhashchange();
        }
    }
 
    createContent() {
        
        return (
            <div id = {this.props.id}>
                <Page  {...this.state} jsPath={this.state.jsPath+'.w.js'}>
                </Page>
            </div>
        );
    }

}

//     createContent() {
//         let url = this.state.jsPath;
//         if(url !== null&&url !== undefined)
//             url = /.js$/.test(url)?url:url.replace(/\.[^\.]+$/, ".js");
//         return (
//             <div id = {this.props.id}>
//                 <Page  {...this.state} jsPath={url}>
//                 </Page>
//             </div>
//         );
//     }

// }